/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Trans, useTranslation } from 'react-i18next';
import { Anchor, Heading, Size } from '@vaisala-rockhopper/components';
import { ModalInstance, ModalProps } from './Modals';
import './Modals.scss';

export const HelpModal = (props: ModalProps) => {
  const { t } = useTranslation();
  return (
    <ModalInstance modalId="modal.help" {...props} title={t('ui.help')} size={Size.L}>
      <Heading level={4}>{t('modalHeading.help')}</Heading>
      <Trans><p className="vai-body-text">{t('modalText.help1')} </p></Trans>
      <Trans>
        <p className="vai-body-text">
          {t('modalText.help2')}
        </p>
      </Trans>
      <Trans>
        <p className="vai-body-text">
          {t('modalText.help3')}
        </p>
      </Trans>
      <Trans>
        <p className="vai-body-text">
          {t('modalText.disclaimer')}
        </p>
      </Trans>
      <Trans>
        <p className="vai-body-text">
          {t('modalText.theory')}
        </p>
      </Trans>
      <Trans>
        <p className="vai-body-text">
          {t('modalText.feedback')}
        </p>
      </Trans>
      {/* <Trans>
        {t('modalText.betaTest')}{' '}
        <br/>
        <Anchor
          to="https://forms.office.com/r/HgyBYgmWzK"
          openInNewWindow={true}
        >
          Bug report form
        </Anchor>{' '}
      </Trans> */}
    </ModalInstance>
  );
};
